const handleSaveAsterisc = (editor,savedPagesPerProject,setSavedPagesPerProject,selectedPage,selectedProject,setEnableBreadcrumb) => {
    
    if (editor !== undefined && editor.BlockManager !== undefined) {
        editor.on('load', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === false) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = true;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
  
        editor.on('storage:end:load', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === false) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = true;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
  
        editor.on('component:update', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === true) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = false;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
  
        editor.on('run:view-annotations', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            setEnableBreadcrumb(false);
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === false) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = true;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
  
        editor.on('stop:view-annotations', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            setEnableBreadcrumb(true);
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === false) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = true;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
  
        editor.on('component:add', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === true) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = false;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
        editor.on('component:remove', () => {
          if (selectedProject > -1 && selectedPage > -1) {
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            if (tempSavedPagesPerProject[selectedProject][selectedPage] === true) {
              tempSavedPagesPerProject[selectedProject][selectedPage] = false;
              setSavedPagesPerProject(tempSavedPagesPerProject);
            }
          }
        });
    }
}

export default handleSaveAsterisc;